/*
 * Digital Purchase Order
 *
 * Copyright (c) 2025 LeBog Software GmbH, Germany.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are not permitted.
 */
//@flow

let x = $;

$.observable.Object.prototype.setPropertyR = function (newData) {
    for (var prop in newData) {
        if (prop.startsWith('jQuery')) {
            continue;
        }

        if (!this._data || typeof this._data[prop] == 'undefined' || this._data[prop] === null) {
            // brand new property
            this.setProperty(prop, newData[prop]);
        } else {
            // existing, non null-property
            if (Array.isArray(newData[prop]) && Array.isArray(this._data[prop])) {
                // replace array with array content
                $.observable(this._data[prop]).refresh(newData[prop]);
            } else if (newData[prop] !== null && typeof newData[prop] == 'object' && typeof this._data[prop] == 'object' && !Array.isArray(this._data[prop]) && !(this._data[prop] instanceof Date)) {
                // merge subobject
                $.observable(this._data[prop]).setPropertyR(newData[prop]);
            } else {
                // set / replace value
                this.setProperty(prop, newData[prop]);
            }
        }
    }

    return this;
};

export {x}